var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccuracy3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002789"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "url(#paint0_linear_484_5171)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9996 21.5491C29.7982 21.5491 37.7415 16.7251 37.7415 10.7745C37.7415 4.82392 29.7982 0 19.9996 0C10.2011 0 2.25781 4.82392 2.25781 10.7745C2.25781 16.7251 10.2011 21.5491 19.9996 21.5491Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.7258 16.3793C15.8855 16.3793 16.8256 15.4392 16.8256 14.2795C16.8256 13.1198 15.8855 12.1797 14.7258 12.1797C13.5661 12.1797 12.626 13.1198 12.626 14.2795C12.626 15.4392 13.5661 16.3793 14.7258 16.3793Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.2737 16.3793C26.4334 16.3793 27.3735 15.4392 27.3735 14.2795C27.3735 13.1198 26.4334 12.1797 25.2737 12.1797C24.114 12.1797 23.1738 13.1198 23.1738 14.2795C23.1738 15.4392 24.114 16.3793 25.2737 16.3793Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.9995 28.5501C22.5231 28.5544 25.0245 29.0211 27.3799 29.9271C26.7491 28.4963 25.7159 27.2799 24.4062 26.4259C23.0964 25.5719 21.5665 25.1172 20.0029 25.1172C18.4393 25.1172 16.9095 25.5719 15.5997 26.4259C14.2899 27.2799 13.2567 28.4963 12.626 29.9271C14.9792 29.0219 17.4782 28.5552 19.9995 28.5501Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_484_5171",
    x1: 20,
    y1: 40,
    x2: 20,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37C7A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccuracy3);
export default __webpack_public_path__ + "static/media/accuracy3.5e260a887722ec3e4df789b703716bf9.svg";
export { ForwardRef as ReactComponent };